(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crazy-home-articles"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mount = (scope = document) => {
      scope.querySelectorAll('[data-crazy-articles-slider]').forEach((root) => {
        if (root.dataset.crazyArticlesMounted === 'true') {
          return;
        }

        const viewport = root.querySelector('[data-crazy-articles-viewport]');
        const track = root.querySelector('[data-crazy-articles-track]');
        const cards = Array.from(root.querySelectorAll('[data-crazy-articles-card]'));
        const dots = Array.from(root.querySelectorAll('[data-crazy-articles-dot]'));
        const prevButton = root.querySelector('[data-crazy-articles-prev]');
        const nextButton = root.querySelector('[data-crazy-articles-next]');
        let activeIndex = 0;
        let resizeFrame = 0;

        if (!viewport || !track || cards.length <= 1) {
          return;
        }

        root.dataset.crazyArticlesMounted = 'true';

        const stepWidth = () => {
          if (!cards.length) {
            return 0;
          }

          const gap = parseFloat(getComputedStyle(track).gap || '0');
          return cards[0].offsetWidth + gap;
        };

        const maxTranslate = () => Math.max(0, track.scrollWidth - viewport.clientWidth);

        const applyTranslate = () => {
          const target = Math.min(activeIndex * stepWidth(), maxTranslate());
          track.style.transform = `translate3d(${-target}px, 0, 0)`;
        };

        const updateDots = () => {
          dots.forEach((dot, dotIndex) => {
            const isActive = dotIndex === activeIndex;
            dot.classList.toggle('is-active', isActive);
            dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
        };

        const update = () => {
          activeIndex = Math.max(0, Math.min(activeIndex, cards.length - 1));
          applyTranslate();
          updateDots();
        };

        prevButton?.addEventListener('click', () => {
          activeIndex = activeIndex === 0 ? cards.length - 1 : activeIndex - 1;
          update();
        });

        nextButton?.addEventListener('click', () => {
          activeIndex = activeIndex === cards.length - 1 ? 0 : activeIndex + 1;
          update();
        });

        dots.forEach((dot, dotIndex) => {
          dot.addEventListener('click', () => {
            activeIndex = dotIndex;
            update();
          });
        });

        window.addEventListener('resize', () => {
          window.cancelAnimationFrame(resizeFrame);
          resizeFrame = window.requestAnimationFrame(update);
        });

        update();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mount, { once: true });
    } else {
      mount();
    }

    document.addEventListener('shopify:section:load', (event) => {
      mount(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crazy-home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mount = () => {
      document.querySelectorAll('[data-crazy-home-hero]').forEach((root) => {
        if (root.dataset.crazyHomeHeroMounted === 'true') {
          return;
        }

        const slides = Array.from(root.querySelectorAll('[data-crazy-home-hero-slide]'));
        let index = 0;
        let timerId;

        if (slides.length === 0) {
          return;
        }

        root.dataset.crazyHomeHeroMounted = 'true';

        const render = () => {
          slides.forEach((slide, slideIndex) => {
            slide.classList.toggle('is-active', slideIndex === index);
          });
        };

        const goTo = (nextIndex) => {
          index = (nextIndex + slides.length) % slides.length;
          render();
        };

        const restart = () => {
          window.clearInterval(timerId);

          if (slides.length > 1) {
            timerId = window.setInterval(() => {
              goTo(index + 1);
            }, 5500);
          }
        };

        render();
        restart();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mount, { once: true });
    } else {
      mount();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crazy-home-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mount = (scope = document) => {
      scope.querySelectorAll('[data-crazy-products-slider]').forEach((root) => {
        if (root.dataset.crazyProductsMounted === 'true') {
          return;
        }

        const viewport = root.querySelector('[data-crazy-products-viewport]');
        const track = root.querySelector('[data-crazy-products-track]');
        const originalSlides = Array.from(track ? track.querySelectorAll('[data-crazy-products-slide]') : []);
        const dots = Array.from(root.querySelectorAll('[data-crazy-products-dot]'));
        const prevButton = root.querySelector('[data-crazy-products-prev]');
        const nextButton = root.querySelector('[data-crazy-products-next]');
        const variantInput = root.querySelector('[data-crazy-products-input]');
        const submitButton = root.querySelector('[data-crazy-products-submit]');
        const submitLabel = root.querySelector('[data-crazy-products-submit-label]');
        const originalCount = originalSlides.length;
        let trackSlides = [];
        let activeTrackIndex = 0;
        let logicalIndex = 0;
        let autoPlayId = 0;
        let transitionFallbackId = 0;
        let resizeFrameId = 0;
        let isAnimating = false;

        if (!viewport || !track || originalCount === 0) {
          return;
        }

        root.dataset.crazyProductsMounted = 'true';

        const setRepositionMode = (enabled) => {
          track.classList.toggle('is-repositioning', enabled);
        };

        const getRealIndex = (slide) => {
          return Number(slide?.dataset.crazyProductsRealIndex || 0);
        };

        const syncPurchaseUi = (activeSlide) => {
          if (!activeSlide) {
            return;
          }

          if (variantInput) {
            variantInput.value = activeSlide.dataset.crazyVariantId || '';
          }

          if (submitButton && submitLabel) {
            const isAvailable = activeSlide.dataset.crazyAvailable === 'true';
            submitButton.disabled = !isAvailable;
            submitLabel.textContent = activeSlide.dataset.crazyButtonLabel || 'Add to cart';
          }
        };

        const updateUi = () => {
          trackSlides.forEach((slide, slideIndex) => {
            const delta = slideIndex - activeTrackIndex;
            slide.classList.toggle('is-active', delta === 0);
            slide.classList.toggle('is-prev', delta === -1);
            slide.classList.toggle('is-next', delta === 1);
          });

          dots.forEach((dot, dotIndex) => {
            const isActive = dotIndex === logicalIndex;
            dot.classList.toggle('is-active', isActive);
            dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          const activeSlide = trackSlides[activeTrackIndex];
          if (!activeSlide) {
            return;
          }

          const offset = activeSlide.offsetLeft - ((viewport.clientWidth - activeSlide.offsetWidth) / 2);
          track.style.transform = `translate3d(${-offset}px, 0, 0)`;
          syncPurchaseUi(activeSlide);
        };

        const render = (options = {}) => {
          const { instant = false } = options;
          if (instant) {
            setRepositionMode(true);
          }

          updateUi();

          if (instant) {
            track.getBoundingClientRect();
            setRepositionMode(false);
          }
        };

        const normalizeTrackPosition = () => {
          if (originalCount <= 1) {
            return;
          }

          let normalizedIndex = activeTrackIndex;
          if (activeTrackIndex < originalCount) {
            normalizedIndex = activeTrackIndex + originalCount;
          } else if (activeTrackIndex >= originalCount * 2) {
            normalizedIndex = activeTrackIndex - originalCount;
          }

          if (normalizedIndex !== activeTrackIndex) {
            activeTrackIndex = normalizedIndex;
            render({ instant: true });
          }
        };

        const finishAnimation = () => {
          if (!isAnimating) {
            return;
          }

          isAnimating = false;
          window.clearTimeout(transitionFallbackId);
          normalizeTrackPosition();
        };

        const moveToTrackIndex = (nextTrackIndex) => {
          if (trackSlides.length === 0) {
            return;
          }

          const boundedIndex = Math.max(0, Math.min(nextTrackIndex, trackSlides.length - 1));
          const nextLogicalIndex = getRealIndex(trackSlides[boundedIndex]);

          if (boundedIndex === activeTrackIndex && nextLogicalIndex === logicalIndex) {
            return;
          }

          if (isAnimating) {
            return;
          }

          activeTrackIndex = boundedIndex;
          logicalIndex = nextLogicalIndex;
          isAnimating = true;
          render();
          transitionFallbackId = window.setTimeout(finishAnimation, 560);
        };

        const findNearestTrackIndex = (targetLogicalIndex) => {
          let bestIndex = activeTrackIndex;
          let bestDistance = Number.POSITIVE_INFINITY;

          trackSlides.forEach((slide, slideIndex) => {
            if (getRealIndex(slide) !== targetLogicalIndex) {
              return;
            }

            const distance = Math.abs(slideIndex - activeTrackIndex);
            if (distance < bestDistance) {
              bestIndex = slideIndex;
              bestDistance = distance;
            }
          });

          return bestIndex;
        };

        const scheduleAutoplay = () => {
          window.clearTimeout(autoPlayId);

          if (originalCount > 1) {
            autoPlayId = window.setTimeout(() => {
              moveToTrackIndex(activeTrackIndex + 1);
              scheduleAutoplay();
            }, 4600);
          }
        };

        originalSlides.forEach((slide, slideIndex) => {
          slide.dataset.crazyProductsRealIndex = String(slideIndex);
        });

        if (originalCount > 1) {
          const buildClone = (slide, slideIndex) => {
            const clone = slide.cloneNode(true);
            clone.classList.remove('is-active');
            clone.dataset.crazyProductsClone = 'true';
            clone.dataset.crazyProductsRealIndex = String(slideIndex);
            return clone;
          };

          const prependFragment = document.createDocumentFragment();
          const appendFragment = document.createDocumentFragment();

          originalSlides.forEach((slide, slideIndex) => {
            prependFragment.appendChild(buildClone(slide, slideIndex));
            appendFragment.appendChild(buildClone(slide, slideIndex));
          });

          track.insertBefore(prependFragment, track.firstChild);
          track.appendChild(appendFragment);
        }

        trackSlides = Array.from(track.querySelectorAll('[data-crazy-products-slide]'));
        const initialLogicalIndex = 0;
        activeTrackIndex = originalCount > 1 ? originalCount + initialLogicalIndex : 0;
        logicalIndex = initialLogicalIndex;

        track.addEventListener('transitionend', (event) => {
          if (event.target !== track || event.propertyName !== 'transform') {
            return;
          }

          finishAnimation();
        });

        track.addEventListener('click', (event) => {
          const slide = event.target.closest('[data-crazy-products-slide]');
          if (!slide || !track.contains(slide)) {
            return;
          }

          const clickedTrackIndex = trackSlides.indexOf(slide);
          if (clickedTrackIndex === -1 || clickedTrackIndex === activeTrackIndex) {
            return;
          }

          if (event.target.closest('a')) {
            event.preventDefault();
          }

          moveToTrackIndex(clickedTrackIndex);
          scheduleAutoplay();
        });

        dots.forEach((dot, dotIndex) => {
          dot.addEventListener('click', () => {
            moveToTrackIndex(findNearestTrackIndex(dotIndex));
            scheduleAutoplay();
          });
        });

        if (prevButton) {
          prevButton.addEventListener('click', () => {
            moveToTrackIndex(activeTrackIndex - 1);
            scheduleAutoplay();
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', () => {
            moveToTrackIndex(activeTrackIndex + 1);
            scheduleAutoplay();
          });
        }

        window.addEventListener('resize', () => {
          window.cancelAnimationFrame(resizeFrameId);
          resizeFrameId = window.requestAnimationFrame(() => {
            render({ instant: true });
          });
        });

        render({ instant: true });
        scheduleAutoplay();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mount, { once: true });
    } else {
      mount();
    }

    document.addEventListener('shopify:section:load', (event) => {
      mount(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crazy-product"] && !Shopify.designMode) return;
  try {
    
  function initCrazyPdp(root = document) {
    const sections = root.querySelectorAll('[data-crazy-pdp]');

    sections.forEach((section) => {
      if (section.dataset.crazyPdpReady === 'true') return;
      section.dataset.crazyPdpReady = 'true';

      /* crazy-pdp-quantity-total-fix */
      const priceNodes = Array.from(section.querySelectorAll('[data-crazy-pdp-total]'));
      const variantInput = () => section.querySelector('input[name="id"]');
      const quantityInput = () => section.querySelector('input[name="quantity"]');
      const variantDataNode = section.querySelector('[data-crazy-pdp-variant-data]');
      let variantData = [];

      try {
        variantData = JSON.parse(variantDataNode?.textContent || '[]');
      } catch (error) {
        variantData = [];
      }

      const variantsById = new Map(
        variantData.map((variant) => [String(variant.id), variant])
      );

      const toCents = (value) => {
        if (value === null || value === undefined || value === '') return null;
        const raw = String(value).trim();
        const numeric = Number(raw);
        if (!Number.isFinite(numeric)) return null;
        return raw.includes('.') ? Math.round(numeric * 100) : Math.round(numeric);
      };

      const formatTotal = (cents, format) => {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents, format);
        }

        const amount = (cents / 100).toFixed(2);
        const amountNoDecimals = String(Math.round(cents / 100));
        const fallback = format || '$0.00';
        return fallback
          .replace(/\{\{\s*amount\s*\}\}/g, amount)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
      };

      const updateProductTotal = (variantOverride) => {
        const input = quantityInput();
        const quantity = Math.max(1, parseInt(input?.value, 10) || 1);
        const id = variantOverride?.id || variantInput()?.value;
        const mappedVariant = id ? variantsById.get(String(id)) : null;
        const unitCents = toCents(variantOverride?.price ?? mappedVariant?.price ?? priceNodes[0]?.dataset.unitPrice);
        if (unitCents === null) return;

        const format = priceNodes[0]?.dataset.moneyFormat || '$0.00';
        priceNodes.forEach((node) => {
          node.dataset.unitPrice = String(unitCents);
          node.textContent = formatTotal(unitCents * quantity, format);
        });
      };

      const readVariantEvent = (event) => {
        const detail = event?.detail || {};
        return detail.variant || detail.selectedVariant || detail;
      };

      section.addEventListener('input', (event) => {
        if (event.target?.matches?.('input[name="quantity"]')) updateProductTotal();
      });
      section.addEventListener('change', (event) => {
        if (event.target?.matches?.('input[name="quantity"]')) updateProductTotal();
        if (event.target?.matches?.('input[name="id"]')) updateProductTotal();
      });
      section.addEventListener('quantity-selector:update', () => updateProductTotal());
      section.addEventListener('variant:update', (event) => updateProductTotal(readVariantEvent(event)));
      section.addEventListener('variant:selected', (event) => updateProductTotal(readVariantEvent(event)));
      document.addEventListener('variant:update', (event) => {
        if (section.contains(event.target) || event.detail?.sectionId === section.id) {
          updateProductTotal(readVariantEvent(event));
        }
      });

      const form = section.querySelector('form[data-type="add-to-cart-form"]');
      const observer = new MutationObserver(() => updateProductTotal());
      if (form) observer.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
      updateProductTotal();

      const toggle = section.querySelector('[data-crazy-pdp-toggle]');
      const shortCopy = section.querySelector('.crazy-pdp__description--short');
      const fullCopy = section.querySelector('[data-crazy-pdp-full]');

      if (toggle && shortCopy && fullCopy) {
        toggle.addEventListener('click', () => {
          const expanded = section.dataset.crazyPdpExpanded === 'true';
          section.dataset.crazyPdpExpanded = expanded ? 'false' : 'true';
          shortCopy.hidden = !expanded;
          fullCopy.hidden = expanded;
          toggle.textContent = expanded ? 'Show more' : 'Show less';
        });
      }

      const gallery = section.querySelector('[data-crazy-pdp-gallery]');
      if (!gallery) return;

      const track = gallery.querySelector('[data-crazy-pdp-track]');
      const slides = Array.from(gallery.querySelectorAll('[data-crazy-pdp-slide]'));
      const thumbs = Array.from(gallery.querySelectorAll('[data-crazy-pdp-thumb]'));
      const counter = gallery.querySelector('[data-crazy-pdp-counter]');
      const prev = gallery.querySelector('[data-crazy-pdp-prev]');
      const next = gallery.querySelector('[data-crazy-pdp-next]');

      if (!track || slides.length === 0) return;

      let activeIndex = 0;
      let scrollFrame = null;

      const formatCount = (value) => String(value).padStart(2, '0');

      const updateGallery = (index) => {
        activeIndex = index;

        thumbs.forEach((thumb, thumbIndex) => {
          const isActive = thumbIndex === index;
          thumb.classList.toggle('is-active', isActive);
          if (isActive) {
            thumb.setAttribute('aria-current', 'true');
            thumb.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'center',
            });
          } else {
            thumb.removeAttribute('aria-current');
          }
        });

        if (counter) {
          counter.textContent = `${formatCount(index + 1)} / ${formatCount(slides.length)}`;
        }

        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === slides.length - 1;
      };

      const scrollToSlide = (index) => {
        const boundedIndex = Math.max(0, Math.min(index, slides.length - 1));
        const targetSlide = slides[boundedIndex];
        if (!targetSlide) return;
        track.scrollTo({
          left: targetSlide.offsetLeft,
          behavior: 'smooth',
        });
        updateGallery(boundedIndex);
      };

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = Number(thumb.dataset.index || 0);
          scrollToSlide(index);
        });
      });

      if (prev) {
        prev.addEventListener('click', () => scrollToSlide(activeIndex - 1));
      }

      if (next) {
        next.addEventListener('click', () => scrollToSlide(activeIndex + 1));
      }

      track.addEventListener(
        'scroll',
        () => {
          if (scrollFrame) cancelAnimationFrame(scrollFrame);
          scrollFrame = requestAnimationFrame(() => {
            const currentLeft = track.scrollLeft;
            let closestIndex = 0;
            let closestDistance = Infinity;

            slides.forEach((slide, index) => {
              const distance = Math.abs(slide.offsetLeft - currentLeft);
              if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
              }
            });

            updateGallery(closestIndex);
          });
        },
        { passive: true }
      );

      updateGallery(0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCrazyPdp());
  } else {
    initCrazyPdp();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCrazyPdp(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
